/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Sub_Cancel_ScheduledInputs */

const en_settings_sub_cancel_scheduled = /** @type {(inputs: Settings_Sub_Cancel_ScheduledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cancelled — access continues until ${i?.date}.`)
};

const id_settings_sub_cancel_scheduled = /** @type {(inputs: Settings_Sub_Cancel_ScheduledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dibatalkan — akses tetap sampai ${i?.date}.`)
};

/**
* | output |
* | --- |
* | "Cancelled — access continues until {date}." |
*
* @param {Settings_Sub_Cancel_ScheduledInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_cancel_scheduled = /** @type {((inputs: Settings_Sub_Cancel_ScheduledInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_Cancel_ScheduledInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_cancel_scheduled(inputs)
	return en_settings_sub_cancel_scheduled(inputs)
});